<ng-container *transloco="let convert;">
  @if (showHeading) {
    <h3 class="text-uppercase fw-bold h5 mb-3">{{convert('sellModule.details.sellerUpdate.sellerUpdates')}}</h3>
  }

  <section class="seller-updates" [class.mb-5]="showHeading">
    <div class="qa-content">
      @for (question of questions$ | async; track question) {
        <div>
          <p class="seller-updates__updates mb-2">
            <span class="fw-bold">{{convert('sellModule.details.sellerUpdate.question')}}</span> {{convert('sellModule.details.sellerUpdate.on')}} {{ localizeDate(question.askedDate) }} -
            {{ question.question }}
          </p>
          @if (question.answeredDate) {
            <p class="seller-updates__updates">
              <span class="fw-bold">{{convert('sellModule.details.sellerUpdate.sellerResponse')}}</span> {{convert('sellModule.details.sellerUpdate.on')}} {{ localizeDate(question.answeredDate) }} -
              {{ question.answer }}
            </p>
          }
        </div>
      }
    </div>
  </section>
</ng-container>
